import { Link } from 'react-router-dom';
import './Footer.css';
import { useTranslation } from '../i18n/LanguageContext.jsx';
import { ROUTES } from '../config/routes.js';

/**
 * Footer component with copyright, social links, and privacy policy link.
 *
 * @param {Object} props
 * @param {Function} [props.onPrivacyClick] - Callback to open the privacy policy modal
 * @param {Function} [props.onCookieSettingsClick] - Callback to open cookie settings
 */
function Footer({ onPrivacyClick, onCookieSettingsClick }) {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p>{t('footer.copyright', { year: currentYear })}</p>
          <div className="footer-links">
            <a
              href="https://www.youtube.com/@ExplainIT-HU"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer.youtube')}
            </a>
            <a href="https://instagram.com/yourhandle" target="_blank" rel="noopener noreferrer">
              {t('footer.instagram')}
            </a>
            <Link to={ROUTES.impresszum} className="footer-impresszum-link">
              {t('footer.impresszum')}
            </Link>
            {onPrivacyClick && (
              <button className="footer-privacy-link" onClick={onPrivacyClick} type="button">
                {t('privacyPolicy.title')}
              </button>
            )}
            {onCookieSettingsClick && (
              <button
                className="footer-cookie-settings-link"
                onClick={onCookieSettingsClick}
                type="button"
              >
                {t('footer.cookieSettings')}
              </button>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
